import React, { useEffect, useRef } from 'react'

const SCRIPT_ID = 'cloudflare-turnstile-script'
const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
let turnstileLoader

const loadTurnstile = () => {
  if (window.turnstile) return Promise.resolve(window.turnstile)
  if (turnstileLoader) return turnstileLoader

  turnstileLoader = new Promise((resolve, reject) => {
    const existing = document.getElementById(SCRIPT_ID)
    const script = existing || document.createElement('script')
    script.id = SCRIPT_ID
    script.src = SCRIPT_URL
    script.async = true
    script.defer = true
    script.addEventListener('load', () => resolve(window.turnstile), { once: true })
    script.addEventListener('error', (error) => {
      turnstileLoader = null
      reject(error)
    }, { once: true })
    if (!existing) document.head.appendChild(script)
  })

  return turnstileLoader
}

const Turnstile = ({
  onError,
  onExpire,
  onVerify,
  resetSignal,
}) => {
  const containerRef = useRef(null)
  const widgetIdRef = useRef(null)

  useEffect(() => {
    let mounted = true
    const sitekey = process.env.REACT_APP_TURNSTILE_SITE_KEY

    if (!sitekey) {
      onError()
      return undefined
    }

    loadTurnstile()
      .then((turnstile) => {
        if (!mounted || !containerRef.current) return
        widgetIdRef.current = turnstile.render(containerRef.current, {
          sitekey,
          action: 'qr_login',
          appearance: 'interaction-only',
          execution: 'render',
          size: 'flexible',
          theme: 'light',
          callback: onVerify,
          'expired-callback': onExpire,
          'error-callback': onError,
        })
      })
      .catch(onError)

    return () => {
      mounted = false
      if (widgetIdRef.current !== null && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current)
      }
    }
  }, [onError, onExpire, onVerify])

  useEffect(() => {
    if (resetSignal && widgetIdRef.current !== null && window.turnstile) {
      window.turnstile.reset(widgetIdRef.current)
    }
  }, [resetSignal])

  return <div ref={containerRef} className='w-full max-w-sm' />
}

export default Turnstile
